module.exports = __webpack_public_path__ + "static/Liandro-499c27bad7d97b0cc08258a427e1ab81.jpg";